import * as React from 'react'
import { SVGProps } from 'react'

const SvgLockAuthIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#lockAuthIcon_svg__a)'>
      <path
        d='M17 8.002H7v-1a5 5 0 0 1 9.374-2.421 1 1 0 0 0 1.748-.971A6.999 6.999 0 0 0 5.002 7.002v1.424a5 5 0 0 0-3 4.575v6a5.005 5.005 0 0 0 5 4.999H17a5.005 5.005 0 0 0 4.999-5v-5.998a5.005 5.005 0 0 0-5-5Zm-4 8.999a1 1 0 1 1-2 0v-2a1 1 0 0 1 2 0v2Z'
        fill='#3071EE'
      />
    </g>
    <defs>
      <clipPath id='lockAuthIcon_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default SvgLockAuthIcon
